/* Kuratorens arbeidsbord v3 — motion (06.07.2026) */
(function(){
  document.documentElement.classList.add('js-v3');
  var reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function init(){
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target)}})},{threshold:.12});
    document.querySelectorAll('[data-v3stagger]').forEach(function(g){
      Array.prototype.forEach.call(g.children,function(c,i){c.setAttribute('data-v3reveal','');c.style.setProperty('--rd',(i*70)+'ms')});
    });
    document.querySelectorAll('[data-v3reveal]').forEach(function(el){io.observe(el)});
    if(!reduced){
      var img=document.querySelector('.v3-plate>img');
      if(img){
        var ticking=false;
        function move(){
          var r=img.parentElement.getBoundingClientRect();
          if(r.bottom>0&&r.top<window.innerHeight){
            var v=(r.top+r.height/2-window.innerHeight/2)/window.innerHeight;
            img.style.transform='translateY('+(v*-36)+'px)';
          }
          ticking=false;
        }
        window.addEventListener('scroll',function(){if(!ticking){requestAnimationFrame(move);ticking=true}},{passive:true});
        move();
      }
    }
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init)}else{init()}
})();
